var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeownerUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6344 15.0301C37.6344 15.0301 48.6389 15.4476 49.1202 15.0301C49.6015 14.6126 49.8102 13.569 44.0354 13.1515C44.0354 13.1515 45.9835 10.5076 44.4528 10.0902C42.9221 9.6727 39.2346 10.786 38.1214 11.76C37.0081 12.7341 35.8949 14.1256 35.6862 13.7777C35.4774 13.4299 32.7639 12.1079 33.1118 13.4995C33.4597 14.891 34.9169 15.4012 36.2756 15.2157C37.6343 15.0301 36.5965 14.9937 37.6344 15.0301Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5622 37.5782C38.5622 37.5782 42.4818 36.9907 40.8865 25.4752C39.2914 13.9596 36.9453 22.0675 36.9453 22.0675C36.9453 22.0675 33.4578 37.3432 38.5622 37.5782Z",
    fill: "#3EA8A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3546 27.4976L38.1187 39.5679",
    stroke: "#416AA4",
    strokeWidth: 0.184396,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1427 18.9331C18.1427 18.9331 7.07271 19.6007 6.35677 19.4271C5.64084 19.2535 5.90129 17.6907 8.07171 17.3435C10.2422 16.9962 10.6329 17.6907 10.6329 17.6907C10.6329 17.6907 9.2872 15.39 11.8049 14.8691C14.3227 14.3482 15.2343 16.8659 16.3629 16.9528C17.4915 17.0396 19.7055 14.4262 20.0527 16.3406C20.4 18.2551 18.1427 18.9331 18.1427 18.9331Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0392 35.3041C13.0392 35.3041 16.2258 34.7165 14.9289 23.201C13.6321 11.6854 11.7247 19.7933 11.7247 19.7933C11.7247 19.7933 8.8893 35.0691 13.0392 35.3041Z",
    fill: "#3C909E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9553 29.0027L12.7194 37.2937",
    stroke: "#416AA4",
    strokeWidth: 0.184396,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54879 37.4579C9.54879 37.4579 12.7353 36.8703 11.4385 25.3548C10.1416 13.8392 8.23417 21.9471 8.23417 21.9471C8.23417 21.9471 5.39884 37.2229 9.54879 37.4579Z",
    fill: "#3F98A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46491 31.3511L9.229 39.4475",
    stroke: "#416AA4",
    strokeWidth: 0.184396,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70088 39.8446C9.70088 39.8446 12.8295 40.8477 13.3106 41.2764C13.7916 41.705 8.64761 39.6708 9.11057 39.6762C9.57346 39.6815 9.65896 39.8397 9.65896 39.8397",
    fill: "#3D5F98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.328 39.1911L30.8084 39.1604L41.2747 39.1911C41.2747 39.1911 47.9833 41.7521 49.5889 42.2873C51.1946 42.8225 33.1711 40.5778 29.9078 40.4003C26.6445 40.223 20.5529 41.133 18.5019 40.7735C16.4509 40.4141 14.8979 40.3248 14.8979 40.3248C14.8979 40.3248 14.7244 40.3549 15.6214 40.6198C16.5183 40.8849 17.1755 41.963 14.9455 41.6954C12.7155 41.4278 8.2568 39.6407 11.328 39.1911Z",
    fill: "#3D5F98"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.577 34.5681H10.9622V39.1338H21.577V34.5681Z",
    fill: "#FFC19A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8426 36.4712H12.8875V35.7412H13.8426V36.4712Z",
    fill: "#3D5F98"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8426 37.2886H12.8875V36.5587H13.8426V37.2886Z",
    fill: "#3D5F98"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0096 37.2886H14.0544V36.5587H15.0096V37.2886Z",
    fill: "#3D5F98"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0096 36.4712H14.0544V35.7412H15.0096V36.4712Z",
    fill: "#3D5F98"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0518 36.4712H16.0967V35.7412H17.0518V36.4712Z",
    fill: "#3D5F98"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0518 37.2886H16.0967V36.5587H17.0518V37.2886Z",
    fill: "#3D5F98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.219 37.2886H17.2638V36.5587H18.219V37.2886Z",
    fill: "#3D5F98"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.219 36.4712H17.2638V35.7412H18.219V36.4712Z",
    fill: "#3D5F98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7771 34.2038L14.5903 31.6616H22.4029L21.2358 34.2038H10.7771Z",
    fill: "#4C8CCD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.377 34.5681H10.7771V34.2038H21.377V34.5681Z",
    fill: "#475F8D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3948 39.1632L18.9552 39.3416L24.7236 22.6611L27.3401 23.7315L32.3948 39.1632Z",
    fill: "#FFC199"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6717 39.9288H31.1012L24.8653 22.9094L19.0741 39.5416L18.9319 39.9502L18.5526 39.8179L24.6242 22.3804L24.6835 22.4008H34.9815L41.6717 39.9288Z",
    fill: "#416AA4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1023 39.295H25.0803V34.735H27.1023V39.295Z",
    fill: "#3D5F98"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7135 35.7212H21.7583V34.6977H22.7135V35.7212Z",
    fill: "#3D5F98"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7135 36.8676H21.7583V35.8441H22.7135V36.8676Z",
    fill: "#3D5F98"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8805 36.8676H22.9253V35.8441H23.8805V36.8676Z",
    fill: "#3D5F98"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8805 35.7212H22.9253V34.6977H23.8805V35.7212Z",
    fill: "#3D5F98"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4446 19.3951L30.2657 26.6201H29.5333L29.6714 19.3951H30.4446Z",
    fill: "#E2A17D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6715 19.3951L29.5334 26.6201H29.374L28.5715 24.7324V19.3951H29.6715Z",
    fill: "#FFC199"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4445 19.3951H28.5714V18.8768H30.4445V19.3951Z",
    fill: "#C98C6D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2248 40.5685C10.2248 40.5685 9.60914 40.3157 10.3295 39.5427C10.3295 39.5427 10.4081 38.6805 11.5607 38.398C12.7133 38.1155 13.5384 39.1413 13.748 39.3198C13.9575 39.4981 13.6432 39.2751 14.3504 39.2156C15.0577 39.1561 15.1494 40.1224 15.4769 40.2563C15.8043 40.3901 15.5816 40.7469 15.5816 40.7469C15.5816 40.7469 10.4224 40.7498 10.2248 40.5685Z",
    fill: "#3EA8A7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2334 39.9292C11.2334 39.9292 11.8769 40.2614 12.0998 40.6306",
    stroke: "#416AA4",
    strokeWidth: 0.0614653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0398 40.7084C13.0398 40.7084 13.485 40.063 13.8911 40.0481",
    stroke: "#416AA4",
    strokeWidth: 0.0614653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8313 40.3312C11.8313 40.3312 12.0259 40.1411 11.8786 39.9292",
    stroke: "#416AA4",
    strokeWidth: 0.0614653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7237 39.1158C37.7237 39.1158 43.4771 38.7813 41.1357 32.2251C38.7941 25.6688 35.3502 30.2849 35.3502 30.2849C35.3502 30.2849 30.2309 38.982 37.7237 39.1158Z",
    fill: "#3F98A0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6697 35.1735L37.4338 41.1054",
    stroke: "#416AA4",
    strokeWidth: 0.184396,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6697 37.2698L38.5489 36.1994",
    stroke: "#416AA4",
    strokeWidth: 0.184396,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.611 41.1083C37.611 41.1083 47.1162 43.7364 48.3911 43.9543C49.666 44.1723 45.0193 43.562 43.3654 43.179C41.7115 42.7959 40.4091 42.6067 39.7473 42.2427C39.0855 41.8788 36.7838 41.0506 37.611 41.1083Z",
    fill: "#3D5F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeownerUserCard);
export default __webpack_public_path__ + "static/media/homeowner-user-card.4326c87fb9054f7a45b3e4765148a29b.svg";
export { ForwardRef as ReactComponent };